import { getData, patchData, postData, deleteData } from '../../../common/utils/network.utils';

export const search = async (searchParams) => {
    const searchParamsObj = new URLSearchParams();

    Object.entries(searchParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            if (Array.isArray(value)) {
                value.forEach(item => searchParamsObj.append(key, item));
            } else {
                searchParamsObj.append(key, value);
            }
        }
    });

    const queryString = searchParamsObj.toString();
    const url = queryString ? `vault/search?${queryString}` : 'vault/search';

    return (await getData(url)).data;
}

export const fetchVaultById = async (id) => {
    return (await getData(`vault/${id}`)).data;
};

export const fetchVaultMetadata = async () => {
    return (await getData('vault/metadata')).data;
};

export const fetchUserTags = async () => {
    return (await getData('vault/tags')).data;
};

export const fetchUserPeriods = async () => {
    return (await getData('vault/periods')).data;
};

export const updateVaultMetadata = async (id, metadata) => {
    return (await patchData(`vault/${id}/metadata`, metadata)).data;
};

export const downloadVaultFile = async (id) => {
    return ((await getData(`vault/${id}/download`)).data).data;
};

export const deleteVaultFile = async (id) => {
    return await deleteData(`vault/${id}`);
};

export const bulkUpdateMetadata = async (data) => {
    return (await patchData('vault/bulk/metadata', data)).data;
};

export const bulkDownloadUrls = async (data) => {
    return (await postData('vault/bulk/download-urls', data)).data;
};

export const bulkDeleteFiles = async (data) => {
    return (await postData('vault/bulk/delete', data)).data;
};
export const upload = async (formData) => {
    return await postData('vault', formData);
};

export const getVaultsByStatus = async (status) => {
    return (await getData(`vault/status/${status}`)).data;
};

export const getVaultsResults = async () => {
    return (await getData(`vault/results`)).data;
};

export const updateVaultsStatus = async (ids, status) => {
    return await patchData(`vault/status`, { status, ids });
};

export const confirmVaults = async (ids, sendUploadConfirmationEmail = true, forceConfirm = false, assetsIds) => {
    return await postData('vault/confirm', { ids, sendUploadConfirmationEmail, forceConfirm, assetsIds });
};

export const getCurrencyRate = async (currency) => {
    return (await getData(`currencies/live-currency-rate/${currency}`)).data;
}

export const getVaultsFormStep = async () => {
    return (await getData(`vault/form-step`)).data;
}

export const addItems = async (items) => {
    return (await postData("assets/bulk", items));
}
